import React from "react";
import { Link } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { Card } from "primereact/card";

export default function Footer() {
  return (
    <React.Fragment>
      {/* Footer */}
      <footer className=" content-footer footer bg-footer-theme">
        <div className="card">
          <div className="container-xxl d-flex flex-wrap justify-content-between py-3 flex-md-row flex-column">
            <div className="mb-2 mb-md-0">
              <Link to={myroutes.dashboard} className="footer-link">
                Politiques de confidentialités
              </Link>
            </div>
            <div>
              <Link to={"https://www.digiweb.bj"} target="_blank" rel="noopener noreferrer" className="footer-link me-4">
                © 2023 par{" "}
                <span style={{ color: "#FDA639" }}>DIGIWEB SARL </span>. Tous
                droits réservés{" "}
              </Link>
            </div>
          </div>
        </div>
      </footer>
      {/* end Footer */}
    </React.Fragment>
  );
}
